<template>
  <main class="blog">
    <div class="header">
      <b-container class="content" fluid="xs">
        <b-row>
          <b-col>
            <div class="title">
              <img src="@/assets/rebrand/blog/snkrblog-title.svg" class="img-fluid" alt="">
            </div>
            <!-- <h3 class="title">SNKR BLOG</h3> -->
            <h1 class="article">Enter the Sneakerv3rse</h1>
            <p class="date">January 1 2022</p>
            <div class="social-buttons">
              <p class="share-txt">Share</p>
              <b-link v-for="lnk in share" :key="lnk.id" class="blnk">
                <img :src="lnk.img" :alt="lnk.alt" :class="'img-share-' + lnk.alt" />
              </b-link>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="banner-container">
              <img :src="imgBanner" alt="banner" class="img-banner" />
              <img :src="imgBannerFrame" alt="banner" class="img-banner-frame" />
              <!-- <img :src="imgBannerInside" alt="banner" class="img-banner-inside" />
              <img :src="imgUpperLeft" alt="banner" class="img-upper-left" />
              <img :src="imgBottomRight" alt="banner" class="img-bottom-right" /> -->
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p class="desc">
              <b>Hustling</b> is endemic in Sneaker Culture. Let me say that again for the folks in
              the back: Hustling is, has, and <br />
              always will be a part of Sneaker Culture. The hunt for your next pair used to even be
              fun, something you'd <br />
              look forward to. <br/><br class=" -mob-hidden" />

              But the game has become stale, stressful even. Whether you are a Collector, a
              Reseller, or even just <br />
              someone trying to look fly on a Friday night, sneakers are harder and harder to come
              by. Moreover, it seems <br />
              like everyone is rocking the same pair everywhere you go. So, <b>what happened?</b>
              <br class="-mob" /><br class="-mob" />

              What started with small messaging boards online of like minded sneaker freaks has
              blossomed into <br />
              <b>billion dollar businesses</b> jacking up the price of every release all for the
              <b>sake of profit</b> and every kid <br />
              dreaming of hanging with their favorite rappers and dollar signs in their eyes
              <b>looking to get a slice <br />of the pie.</b> No one is lining up down Lafayette or
              9th Street or E. 3rd, but rather everyone is hunched over their laptop, running
              <b> multiple bots.</b> Things done changed. <br class="-mob" /><br class="-mob" />

              Now, I'm not here to knock anyone's hustle! And, maybe I'm just a dying breed. But I
              still think there's <br />
              <b>more to sneakers</b> than just buy, sell, and resell. I, for one, hate my kicks
              being referred to as an asset class. <br />My collection has more than monetary value;
              it is filled with unforgettable memories, good and bad. And, <br />
              while I have documented some of those moments on popular social media platforms, they
              too often felt <br />
              inadequate. My posts were just content created for free running between ads for
              <b
                >another billion dollar <br />
                business</b
              >
              profiting off of me trying to connect with my community. <b>We deserve better.</b>
            </p>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="max-85">
        <b-row>
          <b-col sm="6" class="avatar">
            <div class="left-avatar">
              <img :src="imgSoldier2" alt="soldier" class="img-left-soldier" />
              <img :src="imgLeftFrame" alt="frame" class="img-left-frame" />
            </div>
          </b-col>

          <b-col sm="6" class="avatar">
            <div class="right-avatar">
              <img :src="imgSoldier1" alt="soldier" class="img-right-soldier" />
              <img :src="imgRightFrame" alt="frame" class="img-right-frame" />
            </div>
          </b-col>
        </b-row>
        <img src="@/assets/rebrand/blog/left-grid.png" alt="" class="side-grid left" />
        <img src="@/assets/rebrand/blog/right-grid.png" alt="" class="side-grid right" />
      </b-container>
      <b-container fluid="xs">
        <b-row>
          <b-col>
            <p class="desc">
              The SNKRHUD team strongly believes that time for change has come. Whether or not
              you've been following <br />
              the rise of crypto, NFT's, or Web3 technologies, it's clear <b>something big</b> is
              happening. If you've been around <br />
              long enough, it's easy to call this another fad, but we've all witnessed technology
              accelerating faster and <br />
              faster every year. This just feels different. There's a vast number of incredibly
              smart people working on <br />
              decentralized finance (DeFi), Play-to-Earn (P2E) Gaming, NFT's, and other forms of
              cryptocurrencies. <br class="-mob" /><br class="-mob" />

              For us, Web3 has enabled SNKRHUD to evolve from a "community for sneakerheads" to an
              <b
                >"NFT-based <br />
                playground for sneakerheads immortalizing their collection online in the form of
                digital collectibles they <br />
                can showcase, buy, sell, and battle."</b
              >
              While NFT's have seen a massive surge in interest, we believe Web3 <br />
              technologies have the ability to <b>unlock wealth generation</b> that has typically
              been out-of-reach for the <br />
              communities from which Sneaker Culture emanates. <br class="-mob" /><br
                class="-mob"
              />

              Part of the sneaker game is to purchase any hype sneaker you get access to, whether by
              raffle or early <br />
              access or quick fingers on drop day. Hopefully, everything you buy, you are wearing.
              But every so often the <br />
              secondary market price is too good to pass up and we find ourselves selling a prized
              pair so we can afford <br />
              one or even two others. But if I had the opportunity to hold on to all my pairs, I
              know I would!<br class="-mob" /><br class="-mob" />

              Our <b>DED Stock Creator</b> is the first personal asset class creator, enabling
              anyone to mint their own NFT <br />
              based on a photo of their kicks. Our assets are called DED Stock (Digitally Enabled
              Dopeness). Using our <br />
              editing tools and Filters, turn your sneaker photo into digital artwork other
              collectors will want to own, <br />
              whether your skills are on point, you took a dope photo, or you simply have a rare
              pair. And with these <br />
              digital assets, you set the market value! Sell 1, 10, or 100 NFT's for as little or as
              much as you like, without <br />
              having to actually sell your kicks. Instead of getting a one time return, you can
              monetize again and again <br />
              and again. <br class="-mob" /><br class="-mob" />

              The most popular NFT's at the moment are PFP (Picture for Profile) avatars like you
              see as the profile image <br />
              for Steph Curry, Jay Z, and many other celebrities. SNKRHUD is dropping our own set of 4280 [the original <br />
              product number for the Jordan 1 High Chicago] PFP NFT's we're calling <b>Side Kicks</b>. I'm clearly biased, but <br />
              the artwork is better than any other project I've seen with countless easter eggs for the community. But, we <br />
              want to ensure we're always giving back, so we'll also be giving away another 1000 for free, for those that <br />
              missed out on the drop or even just can't afford them. And next season, we'll drop an entirely new Faction <br />
              of Side Kicks, increasing the value of the previous Faction, whether purchased or acquired for free. And if <br />
              you Battle your Side Kick and your DED Stock, you'll increase their value even further.
            </p>
          </b-col>
        </b-row>
      </b-container>
      <b-container>
        <b-row>
          <b-col>
            <img :src="imgDedStock" alt="ded stock card" class="img-ded-stock" />
          </b-col>
        </b-row>
      </b-container>
      <b-container class="max-85">
        <b-row>
          <b-col>
            <p class="desc mt6">
              Previously, gaming, especially on mobile, meant endless grinding. And after all those
              hours of work, by the time you leveled up your character or achieved that limited
              item, you grew tired of the game, meaning it was all for naught.
              <b>Play-to-Earn Gaming</b> means that you own those assets. Level up a character, sell
              them on the secondary market, and maybe buy a different type of character or even
              start over to create another. All those items you've acquired can also be sold or
              maybe even burned to create something better. All of this is thanks to the power of
              Web3, enabling a new generation of gamers. Our DED Stock are the building blocks of
              our Sneakerv3rse that will unlock this next generation game we're developing as well.
              <br class="-mob" />
              <br class="-mob" />
              This is a ton of information I'm unloading on you right now, but trust me when I say
              this is an exciting new world for the sneakerhead community. This might be foreign to
              you now, but stick with us and I promise that we are here to guide you on the path to
              understanding all of this much much better. <b> We don't win if you don't win</b>
              (literally). We'll dive into more topics like Gameplay and Roadmap for our platform in
              the future, but check out our full White Paper for a taste of what lies ahead for
              SNKRHUD.
            </p>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <span class="note"
              >CEO Brandon Martinez is a veteran entrepreneur having previously founded music
              startup INDMUSIC, most known for working behind the scenes of the <br class="d-none d-md-block"/>2013 viral
              meme, "Harlem Shake." Martinez sold that business to Live Nation in 2016 and went on
              to run their YouTube business for the next three years. <br class="d-none d-md-block"/>His latest cop is the
              Nike SB Dunk Low Mummy's.
            </span>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="max-85">
        <b-row>
          <b-col>
            <ul>
              <li>Tags:</li>
              <li v-for="tag in tags" :key="tag.id">
                <b-link :to="tag.path">
                  {{ tag.name }}
                </b-link>
              </li>
            </ul>
          </b-col>
        </b-row>
      </b-container>
      <hr class="blog-divider" />
      <b-container fluid="sm" class="more-blog">
        <b-row>
          <b-col>
            <b-card-group deck>
              <b-card
                v-for="card in cards"
                :key="card.id"
                :title="card.title"
                :img-src="card.img"
                :img-alt="card.title"
                img-top
              >
                <b-card-text>
                  {{ card.desc }}
                </b-card-text>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-link
              href="https://docsend.com/view/9undhntua5fz2nsc"
              target="_blank"
              class="btn-more-blog"
            >
              <img
                src="@/assets/rebrand/blog/whitepaper.png"
                alt="more blog"
                class="img-more-blog"
              />
            </b-link>
          </b-col>
        </b-row>
        <img src="@/assets/rebrand/blog/spider-web.png" alt="grid" class="spider-web" />
      </b-container>
      <!-- <b-container class="future-hustlers">
        <b-row>
          <b-col>
            <b-link
              href="https://discord.gg/snkrhud"
              target="_blank"
              class="btn-join-now"
            ></b-link>
          </b-col>
        </b-row>
        <img
          src="@/assets/rebrand/blog/future-hustlers-elements.png"
          alt="future hustlers elements"
          class="img-future-hustlers-elements"
        />
        <img
          src="@/assets/rebrand/blog/futurehustlers.png"
          alt="future hustlers"
          class="img-future-hustlers"
        />
      </b-container> -->

      <img src="@/assets/rebrand/blog/grid.png" alt="grid" class="grid" />
    </div>
  </main>
</template>
<script>
export default {
  name: 'SnkrhudNewDirection',
  data() {
    return {
      share: [
        {
          id: 0,
          img: require('../../assets/rebrand/blog/facebook.png'),
          alt: 'facebook',
        },
        {
          id: 1,
          img: require('../../assets/rebrand/blog/twitter.png'),
          alt: 'twitter',
        },
        {
          id: 2,
          img: require('../../assets/rebrand/blog/instagram.png'),
          alt: 'instagram',
        },
        {
          id: 3,
          img: require('../../assets/rebrand/blog/email.png'),
          alt: 'email',
        },
        {
          id: 4,
          img: require('../../assets/rebrand/blog/link.png'),
          alt: 'link',
        },
      ],
      tags: [
        {
          id: 0,
          path: '/',
          name: 'Sport Research',
        },
        {
          id: 1,
          path: '/',
          name: 'Trending',
        },
        {
          id: 2,
          path: '/',
          name: 'Air Jordan',
        },
        {
          id: 3,
          path: '/',
          name: 'Innovation',
        },
      ],
      cards: [
        {
          id: 0,
          title: 'Meet the NYC Adidas Family',
          img: require('../../assets/rebrand/blog/adidas-family.png'),
          desc:
            'Colors that once faded into the background have recently re-emerged, on trend and elevated. From apparel to footwear and everything in between, neutrals and earth tones have become the new canvas for personal expression. And this inspired an idea.',
        },
        {
          id: 1,
          title: 'Why Adizero is the key to unlocking your fast ',
          img: require('../../assets/rebrand/blog/adizero.png'),
          desc:
            "adizero—the pacemaker in performance racing, empowering every runner who's ready to be faster. ",
        },
        {
          id: 2,
          title: 'The Nike Rawdacious Colorway Celebrates the Unity of Sport ',
          img: require('../../assets/rebrand/blog/rawdacious.png'),
          desc:
            "Nike's Rawdacious colorway palette for Tokyo — a combination of white as a primary, with components of pink blast, total orange and bright crimson — is another example of how Nike uses color to imbue deep cultural, psychological and emotional value in its footwear. ",
        },
      ],
      imgBanner: require('../../assets/rebrand/blog/snkrhud.png'),
      imgBannerFrame: require('../../assets/rebrand/blog/frame-line.png'),
      imgSoldier1: require('../../assets/rebrand/blog/soldier.png'),
      imgSoldier2: require('../../assets/rebrand/blog/soldier-2.png'),
      imgLeftFrame: require('../../assets/rebrand/blog/left-frame.png'),
      imgRightFrame: require('../../assets/rebrand/blog/right-frame.png'),
      imgDedStock: require('../../assets/rebrand/blog/ded-stock-card.png'),
      // imgBannerInside: require(`../../assets/rebrand/blog/banner-inside.png`),
      // imgBottomRight:require(`../../assets/rebrand/blog/bottom-right.png`),
      // imgUpperLeft:require(`../../assets/rebrand/blog/upper-left.png`)
    };
  },
};
</script>
<style lang="scss">
@import "../../assets/styles/blog.scss";
</style>
